// assets
import { UserAddOutlined, HistoryOutlined } from '@ant-design/icons';

// icons
const icons = {
  UserAddOutlined,
  HistoryOutlined
};

// ==============================|| MENU ITEMS - User Management ||============================== //

const userManagement = {
  id: 'user-management',
  title: 'User Management',
  type: 'group',
  children: [
    {
      id: 'add-user',
      title: 'Add User',
      type: 'item',
      url: '/user/add',
      icon: icons.UserAddOutlined,
      requiresDeveloperOrSuperAdmin: true
    },
    {
      id: 'activity-logs',
      title: 'Activity Logs',
      type: 'item',
      url: '/activity-logs',
      icon: icons.HistoryOutlined,
      requiresSuperAdmin: true
    }
  ]
};

export default userManagement;
